// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Part 6 Training Log — the task table filled in the app during training.
   Sits under the Confirm / Alert dialogs (9998/9999) so a confirmation raised
   from inside it stays on top. */

.training-log-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9000;
  backdrop-filter: blur(2px);
}

.training-log-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(960px, 94vw);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background-color: var(--color-bg-card);
  border: 2px solid #dc2565;
  border-radius: 8px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.6);
  z-index: 9001;
}

.training-log-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 18px 24px 12px;
  border-bottom: 1px solid var(--color-border);
}

.training-log-header h2 {
  margin: 0 0 4px;
  color: #f06292;
  font-size: 1.3rem;
}

.training-log-subtitle {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 13px;
}

.training-log-progress {
  color: var(--color-text-light);
  font-weight: 600;
}

/* The table scrolls; header and footer stay put. */
.training-log-body {
  overflow-y: auto;
  padding: 0 24px;
}

.training-log-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.training-log-table th {
  position: sticky;
  top: 0;
  background-color: var(--color-bg-card);
  color: var(--color-text-muted);
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  text-align: left;
  padding: 12px 8px 8px;
  border-bottom: 1px solid var(--color-border);
  z-index: 1;
}

.training-log-table th.tick-col {
  text-align: center;
  width: 150px;
}

.training-log-table td {
  padding: 6px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  color: var(--color-text-light);
  vertical-align: middle;
}

.training-log-table .task-label-list {
  margin: 4px 0 0;
  padding-left: 18px;
}

.training-log-table tr.is-heading td {
  padding-top: 16px;
  padding-bottom: 6px;
  color: #f06292;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #dc2565;
}

.training-log-table td.tick-cell {
  text-align: center;
}

.training-log-table td.note-cell {
  text-align: center;
  color: var(--color-text-muted);
  font-size: 12px;
  font-style: italic;
}

/* A tick is a button the full width of its cell: one click stamps the day's
   date, a second clears it. */
.tick-button {
  width: 100%;
  min-height: 30px;
  padding: 4px 8px;
  border: 1px dashed var(--color-border);
  border-radius: 5px;
  background: transparent;
  color: var(--color-text-muted);
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.tick-button:hover:not(:disabled) {
  border-color: #5cb85c;
  color: var(--color-text-light);
}

.tick-button.is-ticked {
  border-style: solid;
  border-color: #5cb85c;
  background-color: rgba(92, 184, 92, 0.15);
  color: #5cb85c;
  font-weight: 600;
  white-space: nowrap;
}

.tick-button.is-ticked:hover:not(:disabled) {
  background-color: rgba(231, 76, 60, 0.15);
  border-color: #e74c3c;
  color: #e74c3c;
}

.tick-button:disabled {
  cursor: default;
  opacity: 0.7;
}

.training-log-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  padding: 14px 24px 18px;
  border-top: 1px solid var(--color-border);
}

.training-log-status {
  flex: 1 1 280px;
  color: var(--color-text-muted);
  font-size: 13px;
}

.training-log-status strong {
  color: var(--color-text-light);
}

.training-log-status.is-signed strong {
  color: #5cb85c;
}

.training-log-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.training-log-loading,
.training-log-error {
  padding: 40px 0;
  text-align: center;
  color: var(--color-text-muted);
}

.training-log-error {
  color: #e74c3c;
}
`, "",{"version":3,"sources":["webpack://./src/components/TrainingLogModal.css"],"names":[],"mappings":"AAAA;;iCAEiC;;AAEjC;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,sCAAsC;EACtC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;8BAC8B;AAC9B;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Part 6 Training Log — the task table filled in the app during training.\n   Sits under the Confirm / Alert dialogs (9998/9999) so a confirmation raised\n   from inside it stays on top. */\n\n.training-log-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 9000;\n  backdrop-filter: blur(2px);\n}\n\n.training-log-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(960px, 94vw);\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--color-bg-card);\n  border: 2px solid #dc2565;\n  border-radius: 8px;\n  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.6);\n  z-index: 9001;\n}\n\n.training-log-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 18px 24px 12px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.training-log-header h2 {\n  margin: 0 0 4px;\n  color: #f06292;\n  font-size: 1.3rem;\n}\n\n.training-log-subtitle {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 13px;\n}\n\n.training-log-progress {\n  color: var(--color-text-light);\n  font-weight: 600;\n}\n\n/* The table scrolls; header and footer stay put. */\n.training-log-body {\n  overflow-y: auto;\n  padding: 0 24px;\n}\n\n.training-log-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.training-log-table th {\n  position: sticky;\n  top: 0;\n  background-color: var(--color-bg-card);\n  color: var(--color-text-muted);\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  text-align: left;\n  padding: 12px 8px 8px;\n  border-bottom: 1px solid var(--color-border);\n  z-index: 1;\n}\n\n.training-log-table th.tick-col {\n  text-align: center;\n  width: 150px;\n}\n\n.training-log-table td {\n  padding: 6px 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  color: var(--color-text-light);\n  vertical-align: middle;\n}\n\n.training-log-table .task-label-list {\n  margin: 4px 0 0;\n  padding-left: 18px;\n}\n\n.training-log-table tr.is-heading td {\n  padding-top: 16px;\n  padding-bottom: 6px;\n  color: #f06292;\n  font-weight: 700;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid #dc2565;\n}\n\n.training-log-table td.tick-cell {\n  text-align: center;\n}\n\n.training-log-table td.note-cell {\n  text-align: center;\n  color: var(--color-text-muted);\n  font-size: 12px;\n  font-style: italic;\n}\n\n/* A tick is a button the full width of its cell: one click stamps the day's\n   date, a second clears it. */\n.tick-button {\n  width: 100%;\n  min-height: 30px;\n  padding: 4px 8px;\n  border: 1px dashed var(--color-border);\n  border-radius: 5px;\n  background: transparent;\n  color: var(--color-text-muted);\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.tick-button:hover:not(:disabled) {\n  border-color: #5cb85c;\n  color: var(--color-text-light);\n}\n\n.tick-button.is-ticked {\n  border-style: solid;\n  border-color: #5cb85c;\n  background-color: rgba(92, 184, 92, 0.15);\n  color: #5cb85c;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.tick-button.is-ticked:hover:not(:disabled) {\n  background-color: rgba(231, 76, 60, 0.15);\n  border-color: #e74c3c;\n  color: #e74c3c;\n}\n\n.tick-button:disabled {\n  cursor: default;\n  opacity: 0.7;\n}\n\n.training-log-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 14px 24px 18px;\n  border-top: 1px solid var(--color-border);\n}\n\n.training-log-status {\n  flex: 1 1 280px;\n  color: var(--color-text-muted);\n  font-size: 13px;\n}\n\n.training-log-status strong {\n  color: var(--color-text-light);\n}\n\n.training-log-status.is-signed strong {\n  color: #5cb85c;\n}\n\n.training-log-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.training-log-loading,\n.training-log-error {\n  padding: 40px 0;\n  text-align: center;\n  color: var(--color-text-muted);\n}\n\n.training-log-error {\n  color: #e74c3c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
